/**
 * Единственное место во всём клиенте, где упоминается WebSocket.
 *
 * Обёртка нужна не ради абстракции ради абстракции: браузерный WebSocket
 * структурно не подставляется вместо узкого интерфейса из-за контравариантности
 * обработчиков, а тестам нужен сокет, которым можно дёргать вручную.
 */
export interface SocketLike {
  send(data: string): void;
  close(): void;
  onopen: (() => void) | null;
  onmessage: ((data: string) => void) | null;
  onclose: (() => void) | null;
  onerror: (() => void) | null;
}

export type SocketFactory = (url: string) => SocketLike;

export const browserSocket: SocketFactory = (url) => {
  const ws = new WebSocket(url);
  const socket: SocketLike = {
    send: (data) => ws.send(data),
    close: () => ws.close(),
    onopen: null,
    onmessage: null,
    onclose: null,
    onerror: null,
  };
  ws.onopen = () => socket.onopen?.();
  ws.onmessage = (event: MessageEvent) => {
    if (typeof event.data === 'string') socket.onmessage?.(event.data);
  };
  ws.onclose = () => socket.onclose?.();
  ws.onerror = () => socket.onerror?.();
  return socket;
};
